import { Tooltip, Typography } from "antd";
import React from "react";
import { CustomMarkerContainer, ParcelNumberContainer } from "./elements";

const { Text } = Typography;

// Define types for props
interface CustomMarkerProps {
  lat: number;
  lng: number;
  title: string;
  src?: string;
  idx?: string | number;
  onClick: () => void;
  client?: boolean;
  car?: boolean;
  status?: string;
}

const CustomMarker: React.FC<CustomMarkerProps> = ({
  lat,
  lng,
  title,
  src,
  idx,
  onClick,
  client,
  car,
  status,
}) => {
  return (
    <CustomMarkerContainer lat={lat} lng={lng} onClick={onClick}>
      {idx && (
        <ParcelNumberContainer
          style={{ backgroundColor: status ? status : "black" }}
        >
          <Text strong style={{ fontSize: "1rem",
            color: "white" }}>
            {idx}
          </Text>
        </ParcelNumberContainer>
      )}
      <Tooltip placement="top" title={title}>
        {src && (
          <>
            {client ? (
              <img
                src={src}
                height="30rem"
                width="30rem"
                alt={title}
                style={{
                  position: "absolute",
                  borderRadius: 10,
                  transform: "translate(-50%, -100%)",
                }}
              />
            ) : car ? (
              <img
                src={src}
                height="40rem"
                width="60rem"
                alt={title}
                style={{
                  position: "absolute",
                  transform: "translate(-50%, -100%)",
                }}
              />
            ) : (
              <img
                src={src}
                height="40rem"
                width="40rem"
                alt={title}
                style={{
                  position: "absolute",
                  transform: "translate(-50%, -100%)",
                }}
              />
            )}
          </>
        )}
      </Tooltip>
    </CustomMarkerContainer>
  );
};

export default CustomMarker;
